/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, Router, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table, Labelbox, Button, FrameBox, Modal } from "../../components";
import PhoneInput from "../../components/PhoneInput";
import { normalizeToE164 } from "../../utils/phoneUtils";
import "./client.scss";
import ValidationLibrary from "../../utils/validationfunction";
import Grid from "@material-ui/core/Grid";
import {
  MASTER_ACTION,
  EMPLOYEE_ACTION,
  CLIENT_ACTION,
} from "../../redux/action";
import {
  Toaster,
  dropdownName,
  encryptPassword,
  decryptPassword,
  generateSecurePassword,
  getRolePath,
  dateTimeFormatter,
} from "../../utils/common";
import { openClientDetailsLink } from "../../utils/clientDetailsSession";
import {
  AddCircleOutlineOutlined,
  Search,
  FilterList,
  RemoveCircleOutline,
  ArrowBack,
  Close,
} from "@material-ui/icons";
import { masterSetup, header, requestHeader } from "./defaultState";
import FiledCopiesDocuments from "../../components/FiledCopiesDocuments/FiledCopiesDocuments";
import SearchIcon from "@material-ui/icons/Search";
import {
  isMaskedEmail,
  getEmailValidationRules,
} from "../../utils/clientEmailMasking";
import {
  canManageSignupClients,
  getSignupClientTypeForEmployee,
} from "../../utils/clientSignupRouting";
import { canChangeClientEmailOrDeleteBusiness } from "../../utils/clientSensitiveEditAccess";

const getEmbeddedClientServices = (client) => {
  if (Array.isArray(client?.services)) return client.services;
  if (Array.isArray(client?.client_services)) return client.client_services;
  if (Array.isArray(client?.requested_services)) return client.requested_services;
  return null;
};

const normalizeServiceCategory = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const filterServicesForRequestTab = (services, requestTypeTab) => {
  const list = Array.isArray(services) ? services : [];
  const tab = normalizeServiceCategory(requestTypeTab);
  if (!tab || tab === "all") return list;
  return list.filter((service) => {
    const category = normalizeServiceCategory(
      service?.service_category || service?.serviceCategory,
    );
    // Nested list APIs already filter by tab; keep a safety filter for mixed payloads.
    if (!category) return true;
    return category === tab || category.startsWith(tab);
  });
};

const requestTabToClientType = (tab) =>
  normalizeServiceCategory(tab) === "business" ? "Business" : "Individual";

const requestTabToServiceCategory = (tab) =>
  normalizeServiceCategory(tab) === "business" ? "business" : "individual";

const formatRequestServiceStatus = (status) => {
  const raw = String(status || "").trim();
  return raw || "Not started";
};

const formatRequestLastUpdated = (service, client) => {
  const raw =
    service?.updated_at ||
    service?.updatedAt ||
    service?.last_updated_at ||
    client?.updatedAt ||
    client?.updated_at ||
    client?.last_updated_at;
  if (!raw) return "—";
  const formatted = dateTimeFormatter(raw);
  if (formatted) return formatted;
  const text = String(raw);
  return text.length >= 10 ? text.slice(0, 10) : text;
};

const toAssignmentArray = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value !== "string") return [];

  const text = value.trim();
  if (!text) return [];

  if (text.startsWith("[") && text.endsWith("]")) {
    try {
      const parsed = JSON.parse(text);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  return [text];
};

const getClientAssignedEmployeeIds = (client) => {
  const ids = [
    ...toAssignmentArray(client?.assigned_employee_uuids),
    ...toAssignmentArray(client?.assigned_employee_ids).filter((id) =>
      /^[0-9a-f-]{36}$/i.test(String(id).trim()),
    ),
    ...toAssignmentArray(client?.assigned_employees).map(
      (employee) => employee?.employee_id || employee?.id,
    ),
    client?.employee_id,
  ];

  return ids
    .filter((id) => id != null)
    .map((id) => String(id).trim())
    .filter(Boolean)
    .filter((id, index, list) => list.indexOf(id) === index);
};

const clientMatchesRevenueEmployees = (client, employeeIds) => {
  if (Number(client?.status) !== 1) return false;
  const wanted = new Set(employeeIds.map((id) => String(id)));
  if (wanted.has(String(client?.employee_id || ""))) return true;
  if (wanted.has(String(client?.sales || ""))) return true;
  return getClientAssignedEmployeeIds(client).some((id) => wanted.has(String(id)));
};

const splitDisplayNames = (value) =>
  toAssignmentArray(value)
    .flatMap((item) =>
      String(item || "")
        .split(",")
        .map((name) => name.trim()),
    )
    .filter(Boolean);

const getClientAssignedEmployeeDisplay = (client, activeEmployees) => {
  const names = [];
  const seen = new Set();
  const pushName = (name) => {
    const text = String(name || "").trim();
    const key = text.replace(/\s+/g, " ").toLowerCase();
    if (text && !seen.has(key)) {
      seen.add(key);
      names.push(text.replace(/\s+/g, " "));
    }
  };

  splitDisplayNames(client?.assigned_employee_names).forEach(pushName);
  splitDisplayNames(client?.assigned_employee_display).forEach(pushName);
  if (names.length) return names.join(", ");

  toAssignmentArray(client?.assigned_employee_ids).forEach((value) => {
    const id = String(value || "").trim();
    const emp = activeEmployees.find((e) => String(e.employee_id) === id);
    if (emp) {
      pushName(dropdownName(emp));
    } else if (!/^[0-9a-f-]{36}$/i.test(id)) {
      pushName(id);
    }
  });

  getClientAssignedEmployeeIds(client).forEach((id) => {
    const emp = activeEmployees.find((e) => String(e.employee_id) === String(id));
    if (emp) pushName(dropdownName(emp));
  });

  return names.join(", ");
};

/** Stack multiple service field values in one table cell (aligned across columns). */
const renderStackedServiceValues = (services, getValue, emptyLabel = "—") => {
  const list = Array.isArray(services) && services.length > 0 ? services : [null];
  return (
    <div className="client-request-service-stack">
      {list.map((service, index) => {
        const key =
          service?.client_service_id ||
          service?.id ||
          `${getValue(service)}-${index}`;
        const value = service ? getValue(service) : emptyLabel;
        return (
          <div key={key} className="client-request-service-line" title={value}>
            {value || "—"}
          </div>
        );
      })}
    </div>
  );
};

const CreateClient = ({ requestMode = false }) => {
  const defaultCreateState = {
    first_name: {
      labelname: "First Name",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    last_name: {
      labelname: "Last Name",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    email: {
      labelname: "Email Address",
      value: "",
      validation: [{ name: "required" }, { name: "emailNew" }],
      error: null,
      errmsg: null,
    },
    password: {
      labelname: "Password",
      password: true,
      value: "",
      validation: [],
      error: null,
      errmsg: null,
    },
    address_1: {
      labelname: "Address 1",
      value: "",
      error: null,
      errmsg: null,
    },
    address_2: {
      labelname: "Address 2",
      value: "",
      error: null,
      errmsg: null,
    },
    phone: {
      labelname: "Phone",
      value: "",
      // validation: [{ name: "required" }, { name: "mobile" }],
      error: null,
      errmsg: null,
    },
    country_id: {
      labelname: "Country",
      value: null,
      type: "select",
      error: null,
      errmsg: null,
    },
    state_id: {
      labelname: "State",
      type: "select",
      value: null,
      error: null,
      errmsg: null,
    },
    city_id: {
      labelname: "City",
      value: null,
      error: null,
      errmsg: null,
    },
    zipcode: {
      labelname: "Zip Code",
      value: "",
      error: null,
      errmsg: null,
    },
    defaultAddress: {
      type: "checkbox",
      label: "Set personal address as business address",
      checked: false,
      disabled: true,
      size: 12,
    },
    business_name: {
      labelname: "Business Name",
      value: "",
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_type: {
      labelname: "Business Type",
      type: "select",
      value: "",
      dropdown: [
        { id: "Sole Proprietorship/DBA", value: "Sole Proprietorship/DBA" },
        {
          id: "Limited Liability Company (LLC)",
          value: "Limited Liability Company (LLC)",
        },
        { id: "S Corporation", value: "S Corporation" },
        { id: "C Corporation", value: "C Corporation" },
        { id: "Non Profit Organization", value: "Non Profit Organization" },
      ],
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_address_1: {
      labelname: "Address 1",
      value: "",
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_address_2: {
      labelname: "Address 2",
      value: "",
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_phone: {
      labelname: "Phone",
      value: "",
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_country_id: {
      labelname: "Country",
      value: null,
      type: "select",
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_state_id: {
      labelname: "State Incorporated",
      type: "select",
      value: null,
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_city_id: {
      labelname: "City",
      value: null,
      disabled: true,
      error: null,
      errmsg: null,
    },
    business_zipcode: {
      labelname: "Zip Code",
      value: "",
      disabled: true,
      error: null,
      errmsg: null,
    },
    client_type: {
      labelname: "Client Type",
      value: "",
      type: "select",
      dropdown: [
        { id: "Individual", value: "Individual" },
        { id: "Business", value: "Business" },
      ],
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    sales: {
      labelname: "Client Manager",
      value: "",
      type: "select",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    employee_id: {
      labelname: "Employee",
      type: "select",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    assigned_employee_ids: {
      labelname: "Assigned Employees",
      type: "select",
      multiple: true,
      value: [],
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    branch_office: {
      labelname: "Branch Office",
      type: "select",
      value: "",
      dropdown: [
        { id: "Sunnyvale - USA", value: "Sunnyvale - USA" },
        { id: "Pleasanton - USA", value: "Pleasanton - USA" },
        { id: "Bangalore - India", value: "Bangalore - India" },
        { id: "Sirsi - India", value: "Sirsi - India" },
      ],
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    source_id: {
      labelname: "Source",
      type: "select",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    do_not_disturb: {
      labelname: "Do Not Disturb",
      type: "select",
      value: "0",
      dropdown: [
        { id: "0", value: "No" },
        { id: "1", value: "Yes" },
      ],
      error: null,
      errmsg: null,
    },
    status: {
      labelname: "Status",
      type: "select",
      value: "1",
      dropdown: [
        { id: "0", value: "Inactive" },
        { id: "1", value: "Active" },
      ],
      error: null,
      errmsg: null,
    },
    Activated: {
      labelname: "Activated",
      value: true, // Default to true
      type: "hidden", // Can be hidden if not needed in UI
      error: null,
      errmsg: null,
    },
  };
  const defaultSearchState = {
    first_name: {
      labelname: "First Name",
      value: "",
      error: null,
      errmsg: null,
    },
    last_name: {
      labelname: "Last Name",
      value: "",
      error: null,
      errmsg: null,
    },
    email: {
      labelname: "Email Address",
      value: "",
      error: null,
      errmsg: null,
    },
    sales: {
      labelname: "Manager",
      value: "",
      type: "select",
      error: null,
      errmsg: null,
    },
    employee_id: {
      labelname: "Employee",
      type: "select",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    assigned_employee_ids: {
      labelname: "Assigned Employees",
      type: "select",
      multiple: true,
      value: [],
      error: null,
      errmsg: null,
    },
    branch_office: {
      labelname: "Branch Office",
      type: "select",
      value: "",
      dropdown: [
        { id: "Sunnyvale - USA", value: "Sunnyvale - USA" },
        { id: "Pleasanton - USA", value: "Pleasanton - USA" },
        { id: "Bangalore - India", value: "Bangalore - India" },
        { id: "Sirsi - India", value: "Sirsi - India" },
      ],
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    business_name: {
      labelname: "Business Name",
      type: "select",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    // contract_no: {
    //   labelname: "Contract No.",
    //   value: "",
    //   error: null,
    //   errmsg: null,
    // },
    invoice_no: {
      labelname: "Invoice",
      value: "",
      error: null,
      errmsg: null,
    },
  };
  const [searchText, setSearchText] = useState("");
  const [clientSearchQuery, setClientSearchQuery] = useState("");
  const [clientTypeFilter, setClientTypeFilter] = useState("all");
  const [requestTypeTab, setRequestTypeTab] = useState(() => {
    const role = localStorage.getItem("user_role");
    if (role === "admin") return "Individual";
    return (
      getSignupClientTypeForEmployee(localStorage.getItem("user_id")) ||
      "Individual"
    );
  });
  /** client_id -> services[] for New Clients Request table */
  const [clientServicesMap, setClientServicesMap] = useState({});
  const customRef = useRef(null);
  /** Full client from getClientById — used on update when form email must not be masked. */
  const editClientDetailRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const revenueEmployeeIds = useMemo(() => {
    const raw = searchParams.get("revenue_employee_ids") || "";
    return raw
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
  }, [searchParams]);
  const [searchAddMode, setSearchAddMode] = useState(false);
  const [resetEvent, setResetEvent] = useState(false);
  const [newClient, setNewClient] = useState(null);
  const [editMode, setEditMode] = useState({
    mode: false,
    client_id: 0,
    /** Preserved when opening edit; used on update so type cannot drift if UI is hidden */
    originalClientType: null,
  });
  const canChangeClientEmail = canChangeClientEmailOrDeleteBusiness();
  const emailLockedOnEdit = editMode.mode && !canChangeClientEmail;

  const normalizeClientTypeForSave = (t) => {
    const s = String(t ?? "")
      .trim()
      .toLowerCase();
    if (s === "business") return "Business";
    if (s === "individual") return "Individual";
    return String(t ?? "").trim() || "";
  };
  const defaultStateSet = (action) => {
    return action ? defaultCreateState : defaultSearchState;
  };
  const [fieldConfiguration, setFieldConfiguration] =
    useState(defaultStateSet());

  const { activeEmployees } = useSelector((state) => state.employee);
  const { allClients } = useSelector((state) => state.client);
  const masterData = useSelector((state) => state.master);
  //for Activate Clients
  const [openActivateModal, setOpenActivateModal] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);
  const [clientsUnderEmployee, setClientsUnderEmployee] = useState([]);
  const userRole = localStorage.getItem("user_role");
  const userId = localStorage.getItem("user_id");
  const isSignupRoutingEmployee = canManageSignupClients(userId);
  const canEditClient =
    userRole === "admin" || userRole === "manager" || isSignupRoutingEmployee;
  const effectiveClientTypeFilter = requestMode
    ? requestTypeTab
    : clientTypeFilter;

  const normalizeSearchValue = (s) =>
    String(s || "")
      .trim()
      .replace(/\s+/g, " ");

  /** Employee/manager: assigned clients by default; "all" only while search has text. */
  const getClientListScope = (searchQuery = clientSearchQuery) =>
    normalizeSearchValue(searchQuery) ? "all" : "assigned";

  const isClientSearchActive = Boolean(normalizeSearchValue(clientSearchQuery));
  const clientTableActions = useMemo(() => {
    if (!canEditClient) return [];
    return requestMode ? ["edit"] : ["edit"];
  }, [canEditClient, requestMode]);
  const clientTableHeader = useMemo(() => {
    let cols = requestMode ? requestHeader : header;
    if (
      requestMode &&
      requestTabToServiceCategory(requestTypeTab) !== "business"
    ) {
      cols = cols.filter((col) => col.id !== "businessName");
    }
    return canEditClient ? cols : cols.filter((col) => col.id !== "action");
  }, [canEditClient, requestMode, requestTypeTab]);
  let Clients;
  useEffect(() => {
    //console.log("All Clients: ", allClients);  // Debugging line
  }, [allClients]);

  /////************ API DATA PROCESS************////////////
  useEffect(() => {
    dispatch(EMPLOYEE_ACTION.getActiveEmployees());
    if (requestMode) return;
    if (localStorage.getItem("user_role") === "admin") {
      dispatch(CLIENT_ACTION.getAllClients());
    }
  }, [dispatch, searchAddMode, requestMode]);

  // Employee/manager: load assigned clients on mount (search uses separate API call)
  useEffect(() => {
    if (requestMode) return;
    if (localStorage.getItem("user_role") === "admin") return;
    if (isClientSearchActive) return;
    if (revenueEmployeeIds.length) {
      const role = localStorage.getItem("user_role");
      if (role === "manager") {
        dispatch(
          CLIENT_ACTION.getAllClients({
            scope: "assigned",
            manager_id: localStorage.getItem("user_id") || "",
            include_subordinate_tree: "true",
          }),
        );
      } else {
        dispatch(CLIENT_ACTION.getAllClients({ scope: "assigned" }));
      }
      return;
    }
    dispatch(CLIENT_ACTION.getAllClients({ scope: "assigned" }));
  }, [
    dispatch,
    searchAddMode,
    isClientSearchActive,
    requestMode,
    revenueEmployeeIds,
  ]);

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    console.log("USER ID: ", userId); // Debugging line

    let filteredClients;

    if (localStorage.getItem("user_role") === "admin") {
      // Admin sees all clients, but filter out activated ones
      filteredClients = allClients.filter((client) => !client.Activated);
    } else {
      // Non-admin sees only their clients (assigned to them or manager) who are not activated
      const isAssignedToUser = (client) => {
        if (client.employee_id === userId || client.sales === userId)
          return true;
        const ids = getClientAssignedEmployeeIds(client);
        if (
          Array.isArray(ids) &&
          ids.some((id) => String(id) === String(userId))
        )
          return true;
        return false;
      };
      filteredClients = allClients.filter(
        (client) => isAssignedToUser(client) && !client.Activated,
      );
    }

    // console.log("Filtered Clients (Not Activated): ", filteredClients);  // Debugging line
    setClientsUnderEmployee(filteredClients);
  }, [allClients]);

  const employeeDropdown = () => {
    const employeeData = activeEmployees.map((data) => {
      return {
        id: data.employee_id,
        value: dropdownName(data),
      };
    });
    //console.log("ALL EMPLOYEE DATA IS: ",employeeData);
    const managerData = activeEmployees
      .filter((data) => data.role_id === 2) // Only include role_id == 2
      .map((data) => ({
        id: data.employee_id,
        value: dropdownName(data),
      }));
    // console.log("ALL MANAGER DATA IS: ",managerData);
    const isManagerDropdownVisible = managerData.length > 0;
    //console.log("Manager Data Available: ", isManagerDropdownVisible);

    //console.log("USER ROLE IS:",localStorage.getItem("first_name"),localStorage.getItem("last_name"),localStorage.getItem("user_role"),localStorage.getItem("user_id"));

    //If no managers are available, assign logged-in user to the manager field
    if (!isManagerDropdownVisible) {
      managerData.push({
        id: localStorage.getItem("user_id"),
        value:
          localStorage.getItem("first_name") +
          " " +
          localStorage.getItem("last_name"),
      });
    }
    if (
      fieldConfiguration.hasOwnProperty("employee_id") ||
      fieldConfiguration.hasOwnProperty("assigned_employee_ids")
    ) {
      setFieldConfiguration((prevState) => ({
        ...prevState,
        employee_id: {
          ...prevState.employee_id,
          dropdown: employeeData,
        },
        assigned_employee_ids: prevState.assigned_employee_ids
          ? { ...prevState.assigned_employee_ids, dropdown: employeeData }
          : prevState.assigned_employee_ids,
        sales: {
          ...prevState.sales,
          dropdown: managerData,
          hide: !isManagerDropdownVisible,
        },
      }));
    }
  };

  // Prefer nested services from signup-request list/search. Batch fallback only — never N+1.
  useEffect(() => {
    if (!requestMode) {
      setClientServicesMap({});
      return undefined;
    }

    let cancelled = false;
    const loadServices = async () => {
      const clients = Array.isArray(allClients) ? allClients : [];
      if (!clients.length) {
        if (!cancelled) setClientServicesMap({});
        return;
      }

      const nextMap = {};
      const needFetchIds = [];

      clients.forEach((client) => {
        const clientId = String(client.client_id || "");
        if (!clientId) return;
        const embedded = getEmbeddedClientServices(client);
        if (embedded) {
          nextMap[clientId] = embedded;
        } else {
          needFetchIds.push(clientId);
        }
      });

      if (needFetchIds.length) {
        const batchMap = await CLIENT_ACTION.getClientServicesByClientIds({
          client_ids: needFetchIds,
          service_category: requestTabToServiceCategory(requestTypeTab),
        });

        if (batchMap && typeof batchMap === "object") {
          needFetchIds.forEach((clientId) => {
            nextMap[clientId] = Array.isArray(batchMap[clientId])
              ? batchMap[clientId]
              : [];
          });
        } else {
          // No per-client fallback — avoid N+1 on initial load.
          needFetchIds.forEach((clientId) => {
            if (!nextMap[clientId]) nextMap[clientId] = [];
          });
        }
      }

      if (!cancelled) setClientServicesMap(nextMap);
    };

    loadServices();
    return () => {
      cancelled = true;
    };
  }, [requestMode, allClients, requestTypeTab]);

  const tableData = useMemo(() => {
    const userId = localStorage.getItem("user_id");
    const userRole = localStorage.getItem("user_role");
    const {
      first_name,
      last_name,
      email,
      employee_id,
      sales,
      branch_office,
      business_name,
    } = fieldConfiguration;

    let source = allClients;
    // Request queue visibility is owned by the API (per-tab open flags). Do not
    // re-filter by client_type / assignment on the client.
    // Default list (no search): employees/managers only see clients assigned to them.
    // Active search uses scope "all" from the API — show returned rows as-is (including
    // signup-routing employees who may search clients not assigned to them).
    if (revenueEmployeeIds.length) {
      source = allClients.filter((client) =>
        clientMatchesRevenueEmployees(client, revenueEmployeeIds),
      );
    } else if (!requestMode && userRole !== "admin" && !isClientSearchActive) {
      const isAssignedToUser = (client) => {
        if (
          String(client.employee_id) === String(userId) ||
          String(client.sales) === String(userId)
        )
          return true;
        const ids = getClientAssignedEmployeeIds(client);
        return (
          Array.isArray(ids) && ids.some((id) => String(id) === String(userId))
        );
      };
      source = allClients.filter(isAssignedToUser);
    }

    const filteredClients = source.filter((client) => {
      // Signup-request list is already scoped by the API for the active tab.
      if (!requestMode) {
        if (
          effectiveClientTypeFilter &&
          effectiveClientTypeFilter !== "all" &&
          String(client.client_type || "").toLowerCase() !==
            effectiveClientTypeFilter.toLowerCase()
        ) {
          return false;
        }
      }

        if (
          first_name?.value &&
          !client.first_name
            ?.toLowerCase()
            .includes(first_name.value.toLowerCase())
        )
          return false;

        if (
          last_name?.value &&
          !client.last_name
            ?.toLowerCase()
            .includes(last_name.value.toLowerCase())
        )
          return false;

        if (
          email?.value &&
          !client.email?.toLowerCase().includes(email.value.toLowerCase())
        )
          return false;

        if (employee_id?.value) {
          const ids = getClientAssignedEmployeeIds(client);
          const matchAssigned =
            Array.isArray(ids) &&
            ids.some((id) => String(id) === String(employee_id.value));
          const matchSingle =
            String(client.employee_id) === String(employee_id.value);
          if (!matchAssigned && !matchSingle) return false;
        }

        if (sales?.value && String(client.sales) !== String(sales.value))
          return false;

        if (
          branch_office?.value &&
          client.branch_office !== branch_office.value
        )
          return false;

        if (
          business_name?.value &&
          client.business_name?.trim() !== business_name.value.trim()
        )
          return false;

      return true;
    });

    const buildClientNameCell = (data) => {
        const {
          client_id,
        first_name: firstName,
        last_name: lastName,
        email: clientEmail,
          do_not_disturb,
          status,
        } = data;
      const listDisplayEmail = clientEmail;

      return (
            <span
              role="link"
              tabIndex={0}
              className="link"
              style={{ fontWeight: 500, color: "#1C74BC", cursor: "pointer" }}
              onClick={() => {
                openClientDetailsLink(navigate, client_id, {
                  state: { client_id, mode: "details", data },
                });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openClientDetailsLink(navigate, client_id, {
                    state: { client_id, mode: "details", data },
                  });
                }
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {do_not_disturb ? (
                    <RemoveCircleOutline
                      style={{
                        color: "#ef4444",
                        fontSize: "20px",
                        marginTop: "2px",
                        flexShrink: 0,
                      }}
                    />
                  ) : (
                    <div style={{ width: "20px", height: "20px" }}></div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    flex: 1,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                {firstName} {lastName}
                    <span
                      style={{
                        width: "8px",
                        height: "8px",
                        marginLeft: "8px",
                        borderRadius: "50%",
                        backgroundColor: status ? "#10b981" : "#ef4444",
                        display: "inline-block",
                        flexShrink: 0,
                      }}
                    />
                  </div>
                  <span style={{ color: "#6b7280", fontSize: "14px" }}>
                    {listDisplayEmail}
                  </span>
                </div>
              </div>
            </span>
      );
    };

    if (requestMode) {
      return filteredClients.map((data) => {
        const {
          client_id,
          email,
          branch_office: rowBranch,
          phone,
          sales_name,
        } = data;
        const clientIdKey = String(client_id || "");
        const services = filterServicesForRequestTab(
          clientServicesMap[clientIdKey] ??
            getEmbeddedClientServices(data) ??
            [],
          requestTypeTab,
        );

        return {
          client_id,
          listDisplayEmail: email,
          clientName: buildClientNameCell(data),
          serviceName: renderStackedServiceValues(
            services,
            (service) =>
              service?.service_name || service?.serviceName || "—",
            "No service requested",
          ),
          ...(requestTabToServiceCategory(requestTypeTab) === "business"
            ? {
                businessName: renderStackedServiceValues(
                  services,
                  (service) =>
                    service?.business_name || service?.businessName || "—",
                ),
              }
            : {}),
          taxYear: renderStackedServiceValues(
            services,
            (service) => service?.tax_year || service?.taxYear || "—",
          ),
          serviceFrequency: renderStackedServiceValues(
            services,
            (service) =>
              service?.service_frequency || service?.serviceFrequency || "—",
          ),
          status: renderStackedServiceValues(services, (service) =>
            formatRequestServiceStatus(service?.status),
          ),
          sales: sales_name || "—",
          branchOffice: rowBranch || "—",
          phone: phone || "—",
          lastUpdated: renderStackedServiceValues(
            services,
            (service) => formatRequestLastUpdated(service, data),
            formatRequestLastUpdated(null, data),
          ),
          filedCopies: (
            <div className="client-request-service-stack">
              {(services.length ? services : [null]).map((service, index) => (
                <div
                  key={
                    service?.client_service_id ||
                    service?.id ||
                    `filed-copies-${index}`
                  }
                  className="client-request-service-line"
                >
                  <FiledCopiesDocuments
                    documents={service?.filed_copies || service?.filedCopies}
                  />
                </div>
              ))}
            </div>
          ),
          enabledActions: canEditClient
            ? { edit: true, file: true }
            : {},
          _clientData: data,
          _services: services,
        };
      });
    }

    return filteredClients.map((data) => {
      const {
        client_id,
        email,
        branch_office: rowBranch,
        phone,
        sales_name,
        employee,
        business_name: rowBusinessName,
      } = data;
      const employeeDisplay =
        getClientAssignedEmployeeDisplay(data, activeEmployees) ||
        employee ||
        "---";

      return {
        client_id,
        listDisplayEmail: email,
        clientName: buildClientNameCell(data),
          businessName: rowBusinessName || "---",
        branchOffice: rowBranch || "---",
          phone: phone || "---",
          sales: sales_name || "---",
          employee: employeeDisplay,
          enabledActions: canEditClient ? { edit: true } : {},
          _clientData: data,
        };
      });
  }, [
    allClients,
    activeEmployees,
    revenueEmployeeIds,
    isClientSearchActive,
    clientSearchQuery,
    searchAddMode,
    newClient,
    fieldConfiguration.business_name.value,
    fieldConfiguration.first_name?.value,
    fieldConfiguration.last_name?.value,
    fieldConfiguration.email?.value,
    fieldConfiguration.employee_id?.value,
    fieldConfiguration.sales?.value,
    fieldConfiguration.branch_office?.value,
    canEditClient,
    requestMode,
    effectiveClientTypeFilter,
    clientServicesMap,
    requestTypeTab,
    navigate,
  ]);

  const masterDataDropdown = () => {
    const mapKeys = Object.keys(masterSetup);
    mapKeys.forEach((data) => {
      if (fieldConfiguration.hasOwnProperty(masterSetup[data])) {
        setFieldConfiguration((prevState) => ({
          ...prevState,
          [masterSetup[data]]: {
            ...prevState[masterSetup[data]],
            dropdown: masterData[data],
          },
        }));
      }
    });

    employeeDropdown();
    businessNameDropdown();
  };

  const businessNameDropdown = () => {
    const businessNames = allClients
      .filter((client) => client.business_name) // Ensure only clients with business names are included
      .map((client) => ({
        id: client.business_name.trim(),
        value: client.business_name.trim(), // Use trimmed business name
      }));

    if (fieldConfiguration.hasOwnProperty("business_name")) {
      setFieldConfiguration((prevState) => ({
        ...prevState,
        business_name: {
          ...prevState.business_name,
          dropdown: businessNames,
        },
      }));
    }
  };

  useEffect(() => {
    businessNameDropdown();
  }, [allClients]);

  /********* RESPONSE ***********/
  useEffect(() => {
    employeeDropdown();
  }, [activeEmployees]);

  useEffect(() => {
    masterDataDropdown();
  }, [masterData]);

  useMemo(() => {
    // employeeDropdown();
    masterDataDropdown();
  }, [searchAddMode, resetEvent]);

  ////////
  /**
   * @function checkValidation used for validation purpose of input fileds
   * @param {string} data input field data
   * @param {string} key input field name
   */
  function checkValidation(data, key) {
    //console.log("Change Key is: ",key, data);
    if (key === "email" && editMode.mode && !canChangeClientEmail) {
      return;
    }
    if (key === "defaultAddress") {
      Object.keys(fieldConfiguration)
        .slice(4, 11)
        .forEach((mapData) => {
          fieldConfiguration[`business_${mapData}`].value = data
            ? fieldConfiguration[mapData].value
            : "";
          if (data && mapData === "country_id") {
            dispatch(
              MASTER_ACTION.getMasterData({
                name: "state",
                name_type: "business_state",
                id: fieldConfiguration[mapData].value,
              }),
            );
          }
        });
    }
    if (key === "client_type") {
      Object.keys(fieldConfiguration)
        .slice(11, 21)
        .forEach((mapData) => {
          fieldConfiguration[mapData].validation =
            data === "Business" &&
            ["business_name", "business_type"].includes(mapData)
              ? [{ name: "required" }]
              : [];
          fieldConfiguration[mapData].disabled =
            data === "Business" ? false : true;

          fieldConfiguration[mapData].value =
            data === "Business" ? fieldConfiguration[mapData].value : null;
        });
      if (data !== "Business") {
        fieldConfiguration.defaultAddress.checked = false;
      }
    }
    if (key === "country_id" || key === "business_country_id") {
      dispatch(
        MASTER_ACTION.getMasterData({
          name: "state",
          name_type: key === "business_country_id" && "business_state",
          id: data,
        }),
      );
    }
    const validationRules =
      key === "email"
        ? getEmailValidationRules(fieldConfiguration[key].validation, data)
        : fieldConfiguration[key].validation;
    const errorcheck = ValidationLibrary.checkValidation(data, validationRules);
    const dynObj = {
      ...fieldConfiguration[key],
      [key === "defaultAddress" ? "checked" : "value"]: data,
      error: !errorcheck.state,
      errmsg: errorcheck.msg,
    };

    setFieldConfiguration((prevState) => ({
      ...prevState,
      [key]: dynObj,
    }));
  }

  const modeChange = (action) => {
    editClientDetailRef.current = null;
    setFieldConfiguration(defaultStateSet(action));
    setSearchAddMode(action);
    editMode.mode &&
      setEditMode({
        mode: false,
        client_id: 0,
        originalClientType: null,
      });
  };

  const getSignupRequestListFilters = (searchQuery = clientSearchQuery) => {
    const clientType = requestTabToClientType(requestTypeTab);
    return {
      signup_requests: true,
      include_services: true,
      client_type: clientType,
      service_category: requestTabToServiceCategory(requestTypeTab),
      search: normalizeSearchValue(searchQuery),
      scope: "all",
    };
  };

  const refreshRequestQueue = (searchQuery = clientSearchQuery) => {
    const filters = getSignupRequestListFilters(searchQuery);
    const trimmed = filters.search;
    if (trimmed) {
      dispatch(
        CLIENT_ACTION.getSearchClient({
          search: trimmed,
          signup_requests: true,
          include_services: true,
          client_type: filters.client_type,
          service_category: filters.service_category,
          scope: "all",
        }),
      );
    } else {
      dispatch(
        CLIENT_ACTION.getAllClients({
          signup_requests: true,
          include_services: true,
          client_type: filters.client_type,
          service_category: filters.service_category,
          scope: "all",
        }),
      );
    }
  };

  const handleCancel = () => {
    editClientDetailRef.current = null;
    if (requestMode) {
      refreshRequestQueue("");
    } else {
    dispatch(
      CLIENT_ACTION.getAllClients(
        localStorage.getItem("user_role") === "admin"
          ? undefined
          : { scope: "assigned" },
      ),
    );
    }
    setFieldConfiguration(defaultStateSet(searchAddMode));
    setResetEvent(!resetEvent);
    setEditMode({ mode: false, client_id: 0, originalClientType: null });
  };

  // Handle new single search field
  const handleClientSearch = () => {
    if (requestMode) {
      refreshRequestQueue(clientSearchQuery);
      return;
    }
    const params = {
      search: normalizeSearchValue(clientSearchQuery),
      scope: getClientListScope(),
      client_type:
        effectiveClientTypeFilter && effectiveClientTypeFilter !== "all"
          ? effectiveClientTypeFilter
          : null,
    };
    console.log("SEARCH PAYLOAD: ", params); // Debugging line
    dispatch(CLIENT_ACTION.getSearchClient(params));
  };

  // Handle search reset
  const handleClientSearchReset = () => {
    setClientSearchQuery("");
    if (requestMode) {
      refreshRequestQueue("");
      return;
    }
    dispatch(
      CLIENT_ACTION.getAllClients(
        localStorage.getItem("user_role") === "admin"
          ? undefined
          : { scope: "assigned" },
      ),
    );
  };

  const fetchClientsByFilters = (delay = 0) => {
    return setTimeout(() => {
      if (requestMode) {
        refreshRequestQueue(clientSearchQuery);
        return;
      }
      const trimmed = normalizeSearchValue(clientSearchQuery);
      const typeParam =
        effectiveClientTypeFilter && effectiveClientTypeFilter !== "all"
          ? effectiveClientTypeFilter
          : null;
      if (trimmed || typeParam) {
        const params = {
          search: trimmed,
          scope: getClientListScope(trimmed),
          client_type: typeParam,
        };
        dispatch(CLIENT_ACTION.getSearchClient(params));
      } else {
        dispatch(
          CLIENT_ACTION.getAllClients(
            localStorage.getItem("user_role") === "admin"
              ? undefined
              : { scope: "assigned" },
          ),
        );
      }
    }, delay);
  };

  // One fetch path for search + type filters (avoids duplicate calls on mount)
  useEffect(() => {
    const delay = normalizeSearchValue(clientSearchQuery) ? 2000 : 0;
    const t = fetchClientsByFilters(delay);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientSearchQuery, clientTypeFilter, requestTypeTab, requestMode]);

  /**
   *
   */
  async function onSubmit() {
    let targetkeys = [];
    for (let key in fieldConfiguration) {
      if (key !== "defaultAddress") targetkeys.push(key);
    }

    // Check if we're in search mode (not create/edit mode)
    // OLD - Multiple search fields (COMMENTED OUT - Keep for reference)
    // if (!searchAddMode && !editMode.mode) {
    //   const params = {};
    //   targetkeys.forEach((data) => {
    //     // FIX: Ensure business_name sends its ID instead of value
    //     if (data === "business_name") {
    //       params[data] =
    //         fieldConfiguration[data].value || fieldConfiguration[data].value;
    //     } else {
    //       params[data] = fieldConfiguration[data].value;
    //     }
    //   });

    //   console.log("SEARCH PAYLOAD: ", params); // Debugging line
    //   dispatch(CLIENT_ACTION.getSearchClient(params));
    //   return;
    // }

    console.log(
      "Submit clicked - searchAddMode:",
      searchAddMode,
      "editMode:",
      editMode.mode,
    );

    const mainvalue = {};
    const validationErrors = [];

    for (const i in targetkeys) {
      const fieldKey = targetkeys[i];
      if (!fieldConfiguration[fieldKey]) continue;

      // Skip password on create (auto-generated) and during edit when empty
      if (fieldKey === "password") {
        if (!editMode.mode) {
          fieldConfiguration[fieldKey].error = false;
          fieldConfiguration[fieldKey].errmsg = null;
          continue;
        }
        if (!fieldConfiguration[fieldKey].value) {
          fieldConfiguration[fieldKey].error = false;
          fieldConfiguration[fieldKey].errmsg = null;
          continue;
        }
      }

      if (editMode.mode && fieldKey === "client_type") {
        fieldConfiguration[fieldKey].error = false;
        fieldConfiguration[fieldKey].errmsg = null;
        mainvalue[fieldKey] = normalizeClientTypeForSave(
          fieldConfiguration[fieldKey].value,
        );
        continue;
      }

      // Skip validation for disabled fields
      if (fieldConfiguration[fieldKey].disabled) {
        fieldConfiguration[fieldKey].error = false;
        fieldConfiguration[fieldKey].errmsg = null;
        continue;
      }

      // Skip validation for fields without validation rules
      const validation = fieldConfiguration[fieldKey].validation || [];
      if (validation.length > 0) {
        // employee_id is not shown on form; we use assigned_employee_ids. Skip validation here so only Assigned Employees is required.
        if (fieldKey === "employee_id") {
          fieldConfiguration[fieldKey].error = false;
          fieldConfiguration[fieldKey].errmsg = null;
          continue;
        }
        // Get the field value - handle null/undefined for select fields
        let fieldValue = fieldConfiguration[fieldKey].value;
        if (fieldConfiguration[fieldKey].type === "select") {
          // For select fields, convert null/undefined to empty string for validation
          if (fieldValue === null || fieldValue === undefined) {
            fieldValue = "";
          }
        }
        // For multiselect (assigned_employee_ids): required = at least one selected
        if (fieldKey === "assigned_employee_ids") {
          const arr = Array.isArray(fieldValue) ? fieldValue : [];
          const hasRequired = validation.some((v) => v.name === "required");
          const errorcheck = {
            state: !hasRequired || arr.length > 0,
            msg:
              hasRequired && arr.length === 0
                ? "At least one employee must be assigned"
                : "",
          };
          fieldConfiguration[fieldKey].error = !errorcheck.state;
          fieldConfiguration[fieldKey].errmsg = errorcheck.msg;
          if (!errorcheck.state && errorcheck.msg) {
            const fieldLabel =
              fieldConfiguration[fieldKey].labelname || fieldKey;
            validationErrors.push(`${fieldLabel}: ${errorcheck.msg}`);
          }
          continue;
        }
        // For text fields, ensure empty string if null/undefined
        if (fieldValue === null || fieldValue === undefined) {
          fieldValue = "";
        }

        const rulesForField =
          fieldKey === "email"
            ? getEmailValidationRules(validation, fieldValue)
            : validation;
        const errorcheck = ValidationLibrary.checkValidation(
          fieldValue,
          rulesForField,
        );
        fieldConfiguration[fieldKey].error = !errorcheck.state;
        fieldConfiguration[fieldKey].errmsg = errorcheck.msg;

        // Collect error messages for display
        if (!errorcheck.state && errorcheck.msg) {
          const fieldLabel = fieldConfiguration[fieldKey].labelname || fieldKey;
          validationErrors.push(`${fieldLabel}: ${errorcheck.msg}`);
        }
      } else {
        // If no validation, ensure error is false
        fieldConfiguration[fieldKey].error = false;
        fieldConfiguration[fieldKey].errmsg = null;
      }
      mainvalue[fieldKey] = fieldConfiguration[fieldKey].value;
    }

    const filtererr = targetkeys.filter(
      (obj) => fieldConfiguration[obj]?.error === true,
    );

    console.log(
      "Validation check - errors found:",
      filtererr.length,
      filtererr,
    );
    console.log("Validation error details:", validationErrors);

    // Log each field with its validation status
    filtererr.forEach((fieldKey) => {
      const field = fieldConfiguration[fieldKey];
      if (field) {
        console.log(
          `Field "${field.labelname || fieldKey}" has error:`,
          field.errmsg || "Unknown error",
        );
      }
    });

    if (filtererr.length === 0) {
      const params = {};
      // Create a copy of targetkeys to avoid mutating the original
      let keysToProcess = [...targetkeys];

      const effectiveClientType = normalizeClientTypeForSave(
        fieldConfiguration.client_type?.value,
      );

      if (effectiveClientType === "Individual") {
        const businessNameIndex = keysToProcess.indexOf("business_name");
        if (businessNameIndex !== -1) {
          keysToProcess.splice(businessNameIndex, 9);
        }
      }

      keysToProcess.forEach((data) => {
        if (fieldConfiguration[data]) {
          let value = fieldConfiguration[data].value;

          // assigned_employee_ids: send array and employee_id (first) for backward compat
          if (data === "assigned_employee_ids") {
            const arr = Array.isArray(value) ? value : [];
            params.assigned_employee_ids = arr;
            params.employee_id = arr.length ? arr[0] : undefined;
            return;
          }
          if (data === "employee_id") return; // use first from assigned_employee_ids instead

          // Normalize phone numbers to E.164 format before sending to backend
          if ((data === "phone" || data === "business_phone") && value) {
            const normalizedPhone = normalizeToE164(value);
            if (normalizedPhone) {
              value = normalizedPhone; // E.164 format: +919110686036
            } else {
              // If normalization fails, try to ensure + prefix as fallback
              value = value.toString().trim();
              if (value && !value.startsWith("+")) {
                value = `+${value}`;
              }
            }
          }

          params[data] = value;
        }
      });

      // Password: auto-generate on create; optional update on edit
      if (!editMode.mode) {
        params.password = encryptPassword(generateSecurePassword());
      } else if (!params.password) {
        delete params.password;
      } else {
        params.password = encryptPassword(params.password);
      }

      if (editMode.mode && "email" in params) {
        if (!canChangeClientEmail) {
          delete params.email;
        } else {
          let emailToSend = params.email;
          if (isMaskedEmail(emailToSend)) {
            let detail = editClientDetailRef.current;
            if (!detail?.email || isMaskedEmail(detail.email)) {
              try {
                detail = await dispatch(
                  CLIENT_ACTION.getClientById(editMode.client_id),
                ).unwrap();
                editClientDetailRef.current = detail;
              } catch (err) {
                console.warn("getClientById refetch for email failed:", err);
              }
            }
            if (detail?.email && !isMaskedEmail(detail.email)) {
              emailToSend = detail.email;
              params.email = emailToSend;
            } else {
              delete params.email;
            }
          }
        }
      }

      // New Clients Request: tell backend which queue tab this assignment is for.
      // Do not send / clear individual_request_open or business_request_open.
      if (requestMode && editMode.mode) {
        params.request_category = requestTabToServiceCategory(requestTypeTab);
        delete params.individual_request_open;
        delete params.business_request_open;
        delete params.client_type; // queue close must not depend on client_type
      }

      console.log(
        "API Call - insertUpdateFlag:",
        editMode.mode ? 1 : 0,
        "params:",
        params,
      );

      try {
        const response = await CLIENT_ACTION.insertUpdateClient({
          params: {
            ...params,
            created_by: localStorage.getItem("email"),
            ...(requestMode && editMode.mode
              ? {}
              : { created_origin: 1 }),
          },
          insertUpdateFlag: editMode.mode ? 1 : 0,
          client_id: editMode.client_id,
        });

        console.log("API Response:", response);

        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.status === 1
        ) {
          Toaster.success(
            `Client ${!editMode.mode ? "created" : "updated"} successfully`,
          );
          setNewClient(response.data.message);
          handleCancel();
          if (requestMode) setSearchAddMode(false);
        } else {
          const errorMsg =
            response?.data?.message ||
            `Error occurred while ${
              !editMode.mode ? "creating" : "updating"
            } the client`;
          Toaster.error(errorMsg);
        }
      } catch (error) {
        console.error("Error creating/updating client:", error);
        Toaster.error(
          `Error occurred while ${
            !editMode.mode ? "creating" : "updating"
          } the client: ${error.message || error}`,
        );
      }
    } else {
      // Show validation errors with details
      console.log("Validation errors:", filtererr);
      const errorMessage =
        validationErrors.length > 0
          ? validationErrors.join(". ")
          : `Please fix ${filtererr.length} validation error(s) before submitting`;
      Toaster.error(errorMessage);

      // Scroll to first error field
      const firstErrorField = filtererr[0];
      if (firstErrorField && fieldConfiguration[firstErrorField]) {
        const fieldLabel =
          fieldConfiguration[firstErrorField].labelname || firstErrorField;
        console.error(`First validation error in field: "${fieldLabel}"`);
      }
    }

    setFieldConfiguration((prevState) => ({
      ...prevState,
    }));
  }

  const onAction = async (type, actionData, actionIndex) => {
    const clientId =
      actionData?.client_id ?? actionData?._clientData?.client_id;
    if (!clientId) {
      Toaster.error("Client not found");
      return;
    }

    let selectedData = actionData._clientData;
    if (!selectedData) {
      selectedData = allClients.find(
        (c) => String(c.client_id) === String(clientId),
      );
    }

    if (!selectedData) {
      Toaster.error("Client data not found");
      return;
    }

    if (type === "edit") {
      if (!canEditClient) {
        Toaster.warning("You do not have permission to edit clients.");
        return;
      }
      customRef.current?.scrollIntoView({ behavior: "smooth" });
      setSearchAddMode(true);
      setEditMode({
        mode: true,
        client_id: selectedData.client_id,
        employee: selectedData.employee_id,
        originalClientType: selectedData.client_type,
      });

      let formData = null;
      try {
        const detail = await dispatch(
          CLIENT_ACTION.getClientById(selectedData.client_id),
        ).unwrap();
        if (!detail) {
          Toaster.error("Could not load client details");
          setEditMode({ mode: false, client_id: 0, originalClientType: null });
          setSearchAddMode(false);
          return;
        }
        editClientDetailRef.current = detail;
        formData = {
          ...detail,
          assigned_employee_ids:
            detail.assigned_employee_ids ??
            selectedData.assigned_employee_ids ??
            (detail.employee_id ? [detail.employee_id] : []),
        };
      } catch (err) {
        console.warn("getClientById failed:", err);
        Toaster.error("Could not load client details for edit");
        setEditMode({ mode: false, client_id: 0, originalClientType: null });
        setSearchAddMode(false);
        editClientDetailRef.current = null;
        return;
      }

      Object.keys(defaultCreateState).forEach((data) => {
        if (data === "password") {
          if (formData.created_origin === 2) {
            defaultCreateState[data].disabled = true;
          }
          defaultCreateState[data].value = decryptPassword(formData[data]);
        } else if (data === "country_id" || data === "business_country_id") {
          dispatch(
            MASTER_ACTION.getMasterData({
              name: "state",
              name_type: data === "business_country_id" && "business_state",
              id: formData[data],
            }),
          );
          if (data === "business_country_id") {
            defaultCreateState[data].disabled = false;
          }
          defaultCreateState[data].value = formData[data];
        } else if (data === "email") {
          defaultCreateState[data].value =
            formData[data] || selectedData.email || "";
          defaultCreateState[data].disabled = false;
        } else if (data === "assigned_employee_ids") {
          defaultCreateState[data].value = Array.isArray(
            formData.assigned_employee_ids,
          )
            ? formData.assigned_employee_ids
            : formData.employee_id
              ? [formData.employee_id]
              : [];
        } else if (
          formData.client_type === "Business" &&
          data.includes("business")
        ) {
          defaultCreateState[data].disabled = false;
          if (
            (data === "phone" || data === "business_phone") &&
            formData[data]
          ) {
            let phoneValue = formData[data].toString().trim();
            if (phoneValue && !phoneValue.startsWith("+")) {
              phoneValue = `+${phoneValue}`;
            }
            defaultCreateState[data].value = phoneValue;
          } else {
            defaultCreateState[data].value = formData[data];
          }
        } else {
          if (
            (data === "phone" || data === "business_phone") &&
            formData[data]
          ) {
            let phoneValue = formData[data].toString().trim();
            if (phoneValue && !phoneValue.startsWith("+")) {
              phoneValue = `+${phoneValue}`;
            }
            defaultCreateState[data].value = phoneValue;
          } else {
            defaultCreateState[data].value = formData[data];
          }
        }
      });
      setFieldConfiguration(defaultCreateState);
    } else if (type === "file") {
      navigate(getRolePath("/documents"), {
        state: {
          clientDetails: {
            client_id: selectedData.client_id,
            home_folder: selectedData?.s3_root_folder,
          },
        },
      });
    }
  };
  const handleCheckboxChange = (client) => {
    setSelectedClients(
      (prev) =>
        prev.some((c) => c.client_id === client.client_id)
          ? prev.filter((c) => c.client_id !== client.client_id) // Remove client
          : [...prev, client], // Add client
    );
  };

  const handleActivateClients = () => {
    console.log(
      "SELECTED CLIENTS FOR ACTIVATION: ",
      selectedClients,
      localStorage.getItem("email"),
    );

    CLIENT_ACTION.handleActivateClients(
      selectedClients,
      localStorage.getItem("email"),
    )
      .then((response) => {
        if (response) {
          console.log("SUCCESS DATA: ", response);
          setOpenActivateModal(false);
          Toaster.success("Client Activation emails sent successfully");
          //window.location.reload();
        } else {
          Toaster.error("Failed to activate clients");
        }
      })
      .catch((error) => {
        console.error("Activation Error: ", error);
        Toaster.error("An error occurred during activation");
      });
  };

  return (
    <div
      style={{
        backgroundColor: "#f5f7fa",
        minHeight: "100%",
        padding: "1.5rem 1.5rem 0",
      }}
    >
      <Grid container alignItems="center" ref={customRef}>
        <style>{`
              /* Scope: only affect grids inside the client form panel in this file */
              .client-form-wrapper {
                /* Counter page padding (1.5rem both sides) so panel can span full width */
                width: calc(100% + 3rem) !important;
                max-width: none !important;
                margin-left: -1.5rem !important;
                margin-right: -1.5rem !important;
                padding-left: 1.5rem !important;
                padding-right: 1.5rem !important;
              }
              .client-form-panel {
                max-width: none !important;
                width: 100% !important;
              }
              .client-form-panel .MuiGrid-container {
                width: 100% !important;
                display: flex !important;
                flex-wrap: wrap !important;
              }
              .client-form-panel .MuiGrid-container > .MuiGrid-item {
                box-sizing: border-box;
                padding-left: 8px;
                padding-right: 8px;
              }
              /* In edit mode make items 3 columns (equal width) */
              .client-form-panel.edit-mode .MuiGrid-container > .MuiGrid-item {
                flex: 0 0 33.3333% !important;
                max-width: 33.3333% !important;
              }
              /* Responsive fallbacks */
              @media (max-width: 960px) {
                .client-form-panel .MuiGrid-container > .MuiGrid-item {
                  flex: 0 0 50% !important;
                  max-width: 50% !important;
                }
                .client-form-wrapper {
                  width: calc(100% + 2rem) !important;
                  margin-left: -1rem !important;
                  margin-right: -1rem !important;
                }
              }
              /* Match Labelbox select: change only border color on hover/focus for search input */
              .dash-search { border-radius: 8px; border: 4px solid transparent; transition: border-color 0.15s ease; }
              .dash-search:hover, .dash-search:focus-within { border-color: #1C74BC; }
            `}</style>
        {!(requestMode && !editMode.mode && !searchAddMode) && (
        <Grid item xs={12}>
            <div className="client-page-header">
              <div className="TitlePane" style={{ fontSize: "24px" }} />
            <div style={{ display: "flex", gap: "12px" }}>
                {requestMode && editMode.mode && (
                  <Button
                    large
                    variant="outline"
                    icon={<ArrowBack />}
                    text="Back"
                    handleClick={() => modeChange(false)}
                  />
                )}
                {!requestMode && (
              <Button
                large
                variant="outline"
                icon={
                  !searchAddMode ? (
                    <AddCircleOutlineOutlined />
                  ) : (
                    <ArrowBack />
                  )
                }
                text={!searchAddMode ? "Create Client" : "Back"}
                handleClick={() =>
                  modeChange(!searchAddMode ? true : false)
                }
              />
                )}
                {!requestMode &&
                  clientsUnderEmployee.some((client) => !client.Activated) && (
                <Button
                  large
                  text="Activate Clients"
                  handleClick={() => setOpenActivateModal(true)}
                />
              )}
            </div>
          </div>
        </Grid>
        )}
        {searchAddMode || editMode.mode ? (
          <div className="client-form-wrapper">
            <div
              className={`client-form-panel panel client-form-single-card ${
                editMode.mode ? "edit-mode" : ""
              }`}
              style={{ width: "100%", maxWidth: "100%" }}
            >
              <div className="client-form-scroll">
                <div className="client-form-section">
                  <div className="panel-heading">
                    <h3 className="panel-title">Select Client Type</h3>
                  </div>
                  <Grid item xs={12} sm={6} md={3}>
                    <Labelbox
                      type={fieldConfiguration.client_type?.type || "text"}
                      labelname={
                        <span>
                          Client Type <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      dropdown={
                        fieldConfiguration.client_type?.type === "select"
                          ? fieldConfiguration.client_type?.dropdown
                          : false
                      }
                      changeData={(e) => checkValidation(e, "client_type")}
                      // disabled={editMode.mode || fieldConfiguration.client_type?.disabled}
                      value={fieldConfiguration.client_type?.value || ""}
                      error={fieldConfiguration.client_type?.error}
                      errmsg={fieldConfiguration.client_type?.errmsg}
                    />
                  </Grid>
                </div>

                {/* Personal Details Section */}
                <div className="client-form-section">
                  <div className="panel-heading">
                    <h3 className="panel-title">Personal Details</h3>
                  </div>
                  <div className="panel-body">
                    <Grid container spacing={editMode.mode ? 3 : 2}>
                      {!editMode.mode && (
                        <>
                          {/* First Name */}
                          <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="text"
                              labelname={
                                <span>
                                  First Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              changeData={(e) =>
                                checkValidation(e, "first_name")
                              }
                              value={
                                (fieldConfiguration.first_name?.value &&
                                  fieldConfiguration.first_name.value
                                    .charAt(0)
                                    .toUpperCase() +
                                    fieldConfiguration.first_name.value
                                      .slice(1)
                                      .toLowerCase()) ||
                                ""
                              }
                              error={fieldConfiguration.first_name?.error}
                              errmsg={fieldConfiguration.first_name?.errmsg}
                            />
                          </Grid>
                          {/* Last Name */}
                          <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="text"
                              labelname={
                                <span>
                                  Last Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              changeData={(e) =>
                                checkValidation(e, "last_name")
                              }
                              value={
                                (fieldConfiguration.last_name?.value &&
                                  fieldConfiguration.last_name.value
                                    .charAt(0)
                                    .toUpperCase() +
                                    fieldConfiguration.last_name.value
                                      .slice(1)
                                      .toLowerCase()) ||
                                ""
                              }
                              error={fieldConfiguration.last_name?.error}
                              errmsg={fieldConfiguration.last_name?.errmsg}
                            />
                          </Grid>
                        </>
                      )}
                      {/* Email — always shown; editable only for admins + allowlisted staff */}
                      <Grid item xs={12} sm={6} md={editMode.mode ? 4 : 4}>
                        <Labelbox
                          type="text"
                          labelname={
                            <span>
                              Email <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          changeData={
                            emailLockedOnEdit
                              ? undefined
                              : (e) => checkValidation(e, "email")
                          }
                          value={fieldConfiguration.email?.value || ""}
                          error={fieldConfiguration.email?.error}
                          errmsg={fieldConfiguration.email?.errmsg}
                          readOnly={emailLockedOnEdit}
                        />
                      </Grid>
                      {editMode.mode && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Labelbox
                            type="text"
                            password={true}
                            labelname="Password (leave blank to keep current)"
                            changeData={(e) => checkValidation(e, "password")}
                            disabled={fieldConfiguration.password?.disabled}
                            value={fieldConfiguration.password?.value || ""}
                            error={fieldConfiguration.password?.error}
                            errmsg={fieldConfiguration.password?.errmsg}
                          />
                        </Grid>
                      )}
                      {/* Phone */}
                      <Grid item xs={12} sm={6} md={editMode.mode ? 4 : 4}>
                        <PhoneInput
                          labelname="Phone No."
                          value={fieldConfiguration.phone?.value || ""}
                          onChange={(value) => {
                            // Ensure value has + prefix
                            const phoneValue =
                              value && !value.startsWith("+")
                                ? `+${value}`
                                : value || "";
                            checkValidation(phoneValue, "phone");
                          }}
                          error={fieldConfiguration.phone?.error}
                          errmsg={fieldConfiguration.phone?.errmsg}
                          disabled={fieldConfiguration.phone?.disabled}
                          required={fieldConfiguration.phone?.validation?.some(
                            (v) => v.name === "required",
                          )}
                        />
                      </Grid>
                      {!editMode.mode && (
                        <>
                          {/* Address 1 */}
                          {/* <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="text"
                              labelname="Address 1"
                              changeData={(e) =>
                                checkValidation(e, "address_1")
                              }
                              value={fieldConfiguration.address_1?.value || ""}
                              error={fieldConfiguration.address_1?.error}
                              errmsg={fieldConfiguration.address_1?.errmsg}
                            />
                          </Grid> */}
                          {/* Address 2 */}
                          {/* <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="text"
                              labelname="Address 2"
                              changeData={(e) => checkValidation(e, "address_2")}
                              value={fieldConfiguration.address_2?.value || ""}
                              error={fieldConfiguration.address_2?.error}
                              errmsg={fieldConfiguration.address_2?.errmsg}
                            />
                          </Grid> */}
                          {/* Country */}
                          {/* <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="select"
                              labelname="Country"
                              dropdown={fieldConfiguration.country_id?.dropdown}
                              changeData={(e) =>
                                checkValidation(e, "country_id")
                              }
                              value={fieldConfiguration.country_id?.value || ""}
                              error={fieldConfiguration.country_id?.error}
                              errmsg={fieldConfiguration.country_id?.errmsg}
                            />
                          </Grid> */}
                          {/* State */}
                          {/* <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="select"
                              labelname="State"
                              dropdown={fieldConfiguration.state_id?.dropdown}
                              changeData={(e) => checkValidation(e, "state_id")}
                              value={fieldConfiguration.state_id?.value || ""}
                              error={fieldConfiguration.state_id?.error}
                              errmsg={fieldConfiguration.state_id?.errmsg}
                            />
                          </Grid> */}
                          {/* City */}
                          {/* <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="text"
                              labelname="City"
                              changeData={(e) => checkValidation(e, "city_id")}
                              value={fieldConfiguration.city_id?.value || ""}
                              error={fieldConfiguration.city_id?.error}
                              errmsg={fieldConfiguration.city_id?.errmsg}
                            />
                          </Grid> */}
                          {/* Zip Code */}
                          {/* <Grid item xs={12} sm={6} md={3}>
                            <Labelbox
                              type="text"
                              labelname="Zip Code"
                              changeData={(e) => checkValidation(e, "zipcode")}
                              value={fieldConfiguration.zipcode?.value || ""}
                              error={fieldConfiguration.zipcode?.error}
                              errmsg={fieldConfiguration.zipcode?.errmsg}
                            />
                          </Grid> */}
                          {/* Checkbox */}
                          {/* {fieldConfiguration.client_type?.value ===
                            "Business" && (
                            <Grid item xs={12}>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={
                                    fieldConfiguration.defaultAddress
                                      ?.checked || false
                                  }
                                  onChange={(e) =>
                                    checkValidation(
                                      e.target.checked,
                                      "defaultAddress",
                                    )
                                  }
                                  disabled={
                                    fieldConfiguration.defaultAddress?.disabled
                                  }
                                />
                                <span>
                                  Set Personal Address As Business Address
                                </span>
                              </label>
                            </Grid>
                          )} */}
                        </>
                      )}
                    </Grid>
                  </div>
                </div>

                {/* Business Details Section */}
                {fieldConfiguration.client_type?.value === "Business" && (
                  <div className="client-form-section">
                    <div className="panel-heading">
                      <h3 className="panel-title">Business Details</h3>
                    </div>
                    <div className="panel-body">
                      <Grid container spacing={2}>
                        {/* Business Name */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type={
                              fieldConfiguration.business_name?.type || "text"
                            }
                            labelname="Business Name"
                            dropdown={
                              fieldConfiguration.business_name?.type ===
                              "select"
                                ? fieldConfiguration.business_name?.dropdown
                                : false
                            }
                            changeData={(e) =>
                              checkValidation(e, "business_name")
                            }
                            disabled={
                              fieldConfiguration.business_name?.disabled
                            }
                            value={
                              fieldConfiguration.business_name?.value || ""
                            }
                            error={fieldConfiguration.business_name?.error}
                            errmsg={fieldConfiguration.business_name?.errmsg}
                          />
                        </Grid>
                        {/* Business Type */}
                        <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type={
                              fieldConfiguration.business_type?.type || "text"
                            }
                            labelname="Business Type"
                            dropdown={
                              fieldConfiguration.business_type?.type ===
                              "select"
                                ? fieldConfiguration.business_type?.dropdown
                                : false
                            }
                            changeData={(e) =>
                              checkValidation(e, "business_type")
                            }
                            disabled={
                              fieldConfiguration.business_type?.disabled
                            }
                            value={
                              fieldConfiguration.business_type?.value || ""
                            }
                            error={fieldConfiguration.business_type?.error}
                            errmsg={fieldConfiguration.business_type?.errmsg}
                          />
                        </Grid>
                        {/* Business Address 1 */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type="text"
                            labelname="Address 1"
                            changeData={(e) =>
                              checkValidation(e, "business_address_1")
                            }
                            disabled={
                              fieldConfiguration.business_address_1?.disabled
                            }
                            value={
                              fieldConfiguration.business_address_1?.value || ""
                            }
                            error={fieldConfiguration.business_address_1?.error}
                            errmsg={
                              fieldConfiguration.business_address_1?.errmsg
                            }
                          />
                        </Grid> */}
                        {/* Business Address 2 */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type="text"
                            labelname="Address 2"
                            changeData={(e) =>
                              checkValidation(e, "business_address_2")
                            }
                            disabled={
                              fieldConfiguration.business_address_2?.disabled
                            }
                            value={
                              fieldConfiguration.business_address_2?.value || ""
                            }
                            error={fieldConfiguration.business_address_2?.error}
                            errmsg={fieldConfiguration.business_address_2?.errmsg}
                          />
                        </Grid> */}
                        {/* Business Phone */}
                        <Grid item xs={12} sm={6} md={3}>
                          <PhoneInput
                            labelname="Phone No."
                            value={
                              fieldConfiguration.business_phone?.value || ""
                            }
                            onChange={(value) => {
                              // Ensure value has + prefix
                              const phoneValue =
                                value && !value.startsWith("+")
                                  ? `+${value}`
                                  : value || "";
                              checkValidation(phoneValue, "business_phone");
                            }}
                            error={fieldConfiguration.business_phone?.error}
                            errmsg={fieldConfiguration.business_phone?.errmsg}
                            disabled={
                              fieldConfiguration.business_phone?.disabled
                            }
                            required={fieldConfiguration.business_phone?.validation?.some(
                              (v) => v.name === "required",
                            )}
                          />
                        </Grid>
                        {/* Business Country */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type="select"
                            labelname="Country"
                            dropdown={
                              fieldConfiguration.business_country_id?.dropdown
                            }
                            changeData={(e) =>
                              checkValidation(e, "business_country_id")
                            }
                            disabled={
                              fieldConfiguration.business_country_id?.disabled
                            }
                            value={
                              fieldConfiguration.business_country_id?.value ||
                              ""
                            }
                            error={
                              fieldConfiguration.business_country_id?.error
                            }
                            errmsg={
                              fieldConfiguration.business_country_id?.errmsg
                            }
                          />
                        </Grid> */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type="select"
                            labelname="State Incorporated"
                            changeData={(e) =>
                              checkValidation(e, "business_state_id")
                            }
                            dropdown={
                              fieldConfiguration.business_state_id?.dropdown
                            }
                            disabled={
                              fieldConfiguration.business_state_id?.disabled
                            }
                            value={
                              fieldConfiguration.business_state_id?.value || ""
                            }
                            error={fieldConfiguration.business_state_id?.error}
                            errmsg={
                              fieldConfiguration.business_state_id?.errmsg
                            }
                          />
                        </Grid> */}
                        {/* Business City */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type="text"
                            labelname="City"
                            changeData={(e) =>
                              checkValidation(e, "business_city_id")
                            }
                            disabled={
                              fieldConfiguration.business_city_id?.disabled
                            }
                            value={
                              fieldConfiguration.business_city_id?.value || ""
                            }
                            error={fieldConfiguration.business_city_id?.error}
                            errmsg={fieldConfiguration.business_city_id?.errmsg}
                          />
                        </Grid> */}
                        {/* Business Zip Code */}
                        {/* <Grid item xs={12} sm={6} md={3}>
                          <Labelbox
                            type="text"
                            labelname="Zip Code"
                            changeData={(e) =>
                              checkValidation(e, "business_zipcode")
                            }
                            disabled={
                              fieldConfiguration.business_zipcode?.disabled
                            }
                            value={
                              fieldConfiguration.business_zipcode?.value || ""
                            }
                            error={fieldConfiguration.business_zipcode?.error}
                            errmsg={fieldConfiguration.business_zipcode?.errmsg}
                          />
                        </Grid> */}
                      </Grid>
                    </div>
                  </div>
                )}

                {/* Finlotax Details Section */}
                <div className="client-form-section">
                  <div className="panel-heading">
                    <h3 className="panel-title">Finlotax Details</h3>
                  </div>
                  <div className="panel-body">
                    <Grid container spacing={2}>
                      {/* Client Manager */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={fieldConfiguration.sales?.type || "text"}
                          labelname={
                            <span>
                              Client Manager{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          dropdown={
                            fieldConfiguration.sales?.type === "select"
                              ? fieldConfiguration.sales?.dropdown
                              : false
                          }
                          changeData={(e) => checkValidation(e, "sales")}
                          disabled={fieldConfiguration.sales?.disabled}
                          value={fieldConfiguration.sales?.value || ""}
                          error={fieldConfiguration.sales?.error}
                          errmsg={fieldConfiguration.sales?.errmsg}
                        />
                      </Grid>
                      {/* Assigned Employees (multiple) */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={
                            fieldConfiguration.assigned_employee_ids?.type ||
                            "select"
                          }
                          multiple={true}
                          labelname={
                            <span>
                              Assigned Employees{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          dropdown={
                            fieldConfiguration.assigned_employee_ids?.type ===
                            "select"
                              ? fieldConfiguration.assigned_employee_ids
                                  ?.dropdown
                              : false
                          }
                          changeData={(e) =>
                            checkValidation(e, "assigned_employee_ids")
                          }
                          disabled={
                            fieldConfiguration.assigned_employee_ids?.disabled
                          }
                          value={
                            Array.isArray(
                              fieldConfiguration.assigned_employee_ids?.value,
                            )
                              ? fieldConfiguration.assigned_employee_ids.value
                              : []
                          }
                          error={
                            fieldConfiguration.assigned_employee_ids?.error
                          }
                          errmsg={
                            fieldConfiguration.assigned_employee_ids?.errmsg
                          }
                        />
                      </Grid>
                      {/* Branch Office */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={
                            fieldConfiguration.branch_office?.type || "text"
                          }
                          labelname={
                            <span>
                              Branch Office{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          dropdown={
                            fieldConfiguration.branch_office?.type === "select"
                              ? fieldConfiguration.branch_office?.dropdown
                              : false
                          }
                          changeData={(e) =>
                            checkValidation(e, "branch_office")
                          }
                          disabled={fieldConfiguration.branch_office?.disabled}
                          value={fieldConfiguration.branch_office?.value || ""}
                          error={fieldConfiguration.branch_office?.error}
                          errmsg={fieldConfiguration.branch_office?.errmsg}
                        />
                      </Grid>
                      {/* Source */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={fieldConfiguration.source_id?.type || "text"}
                          labelname={
                            <span>
                              Source <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          dropdown={
                            fieldConfiguration.source_id?.type === "select"
                              ? fieldConfiguration.source_id?.dropdown
                              : false
                          }
                          changeData={(e) => checkValidation(e, "source_id")}
                          disabled={fieldConfiguration.source_id?.disabled}
                          value={fieldConfiguration.source_id?.value || ""}
                          error={fieldConfiguration.source_id?.error}
                          errmsg={fieldConfiguration.source_id?.errmsg}
                        />
                      </Grid>
                      {/* Client Type */}
                      {/* <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={fieldConfiguration.client_type?.type || "text"}
                          labelname={
                            <span>
                              Client Type{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          dropdown={
                            fieldConfiguration.client_type?.type === "select"
                              ? fieldConfiguration.client_type?.dropdown
                              : false
                          }
                          changeData={(e) => checkValidation(e, "client_type")}
                          disabled={fieldConfiguration.client_type?.disabled}
                          value={fieldConfiguration.client_type?.value || ""}
                          error={fieldConfiguration.client_type?.error}
                          errmsg={fieldConfiguration.client_type?.errmsg}
                        />
                      </Grid> */}
                      {/* Do Not Disturb */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={
                            fieldConfiguration.do_not_disturb?.type || "text"
                          }
                          labelname="Do Not Disturb"
                          dropdown={
                            fieldConfiguration.do_not_disturb?.type === "select"
                              ? fieldConfiguration.do_not_disturb?.dropdown
                              : false
                          }
                          changeData={(e) =>
                            checkValidation(e, "do_not_disturb")
                          }
                          disabled={fieldConfiguration.do_not_disturb?.disabled}
                          value={fieldConfiguration.do_not_disturb?.value || ""}
                          error={fieldConfiguration.do_not_disturb?.error}
                          errmsg={fieldConfiguration.do_not_disturb?.errmsg}
                        />
                      </Grid>
                      {/* Status */}
                      <Grid item xs={12} sm={6} md={3}>
                        <Labelbox
                          type={fieldConfiguration.status?.type || "text"}
                          labelname="Status"
                          dropdown={
                            fieldConfiguration.status?.type === "select"
                              ? fieldConfiguration.status?.dropdown
                              : false
                          }
                          changeData={(e) => checkValidation(e, "status")}
                          disabled={fieldConfiguration.status?.disabled}
                          value={fieldConfiguration.status?.value || ""}
                          error={fieldConfiguration.status?.error}
                          errmsg={fieldConfiguration.status?.errmsg}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </div>

            {/* Form Actions */}
            <div className="client-form-actions">
              <button className="employee-btn-cancel" onClick={handleCancel}>
                Reset
              </button>
              {editMode.mode && !requestMode && (
                <Button
                  text="Activate Client"
                  large
                  handleClick={() => {
                    const activateData = {
                      ...fieldConfiguration,
                      status: { ...fieldConfiguration.status, value: 1 },
                    };
                    setFieldConfiguration(activateData);
                    onSubmit();
                  }}
                />
              )}
              <Button
                text={editMode.mode ? "Update" : "Submit"}
                large
                handleClick={onSubmit}
              />
            </div>
          </div>
        ) : // (
        // <div className="client-search-panel panel">
        //   <div className="panel-heading">
        //     <h3 className="panel-title">Finlotax Details</h3>
        //   </div>
        //   <div className="panel-body">
        //     <Grid container alignItems="center" spacing={2}>
        //       {Object.keys(fieldConfiguration).map((data, index) => {
        //         return (
        //           <Grid
        //             item
        //             xs={12}
        //             md={4}
        //             sm={6}
        //             lg={3}
        //             key={`data${index}`}
        //           >
        //             <Labelbox
        //               type={fieldConfiguration[data]?.type || "text"}
        //               labelname={fieldConfiguration[data]?.labelname}
        //               password={fieldConfiguration[data]?.password}
        //               dropdown={
        //                 fieldConfiguration[data]?.type === "select" &&
        //                 fieldConfiguration[data]?.dropdown
        //                   ? fieldConfiguration[data]?.dropdown
        //                   : false
        //               }
        //               changeData={(e) => checkValidation(e, data)}
        //               disabled={fieldConfiguration[data]?.disabled}
        //               value={fieldConfiguration[data]?.value || ""}
        //               error={fieldConfiguration[data]?.error}
        //               errmsg={fieldConfiguration[data]?.errmsg}
        //               onKeyEnter={onSubmit}
        //             />
        //           </Grid>
        //         );
        //       })}
        //     </Grid>
        //     <div className="client-search-actions">
        //       <button className="employee-btn-cancel" onClick={handleCancel}>
        //         Reset
        //       </button>
        //       <Button text="Search" large handleClick={onSubmit} />
        //     </div>
        //   </div>
        // </div>
        // )
        null}
        {/* {(searchAddMode || editMode.mode) && (
        <Grid item xs={12}>
          <div className="hbox client-form-buttons">
            <Button
              text="Reset"
              large
              handleClick={handleCancel}
            />
            {editMode.mode && (
              <Button
                text="Activate Client"
                large
                handleClick={() => {
                  // Handle activate client
                  const activateData = {
                    ...fieldConfiguration,
                    status: { ...fieldConfiguration.status, value: 1 },
                  };
                  setFieldConfiguration(activateData);
                  onSubmit();
                }}
              />
            )}
            <Button
              text={editMode.mode ? "Update" : "Submit"}
              large
              handleClick={onSubmit}
            />
          </div>
        </Grid>
      )} */}
        <Modal
          className=" timesheet-view-modal"
          open={openActivateModal}
          handleClose={() => setOpenActivateModal(false)}
        >
          <div className="activate-client-container">
            {/* ✅ Header With Close Button */}
            <div className="activate-client-header">
              <h2>Activate Clients</h2>
              <button
                className="close-btn"
                onClick={() => setOpenActivateModal(false)}
              >
                ✕
              </button>
            </div>

            {/* ✅ Search + Activate Button */}
            <div className="activate-client-toolbar">
              <input
                type="text"
                placeholder="Search client by name or email"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              <button
                className="activate-btn"
                onClick={handleActivateClients}
                disabled={selectedClients.length === 0}
              >
                Activate Selected
              </button>
            </div>

            {/* ✅ Select All */}
            <div className="select-all-row">
              <label>
                <input
                  type="checkbox"
                  checked={
                    clientsUnderEmployee.length > 0 &&
                    selectedClients.length === clientsUnderEmployee.length
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedClients([...clientsUnderEmployee]);
                    } else {
                      setSelectedClients([]);
                    }
                  }}
                />
                <span>Select All</span>
              </label>
            </div>

            {/* ✅ Scrollable Client List */}
            <div className="client-list">
              {clientsUnderEmployee
                .filter((client) =>
                  `${client.first_name} ${client.last_name} ${client.email}`
                    .toLowerCase()
                    .includes(searchText.toLowerCase()),
                )
                .map((client) => (
                  <div key={client.client_id} className="client-row">
                    <label>
                      <input
                        type="checkbox"
                        checked={selectedClients.some(
                          (c) => c.client_id === client.client_id,
                        )}
                        onChange={() => handleCheckboxChange(client)}
                      />
                      <span>
                        {client.first_name} {client.last_name} - {client.email}
                      </span>
                    </label>
                  </div>
                ))}
            </div>
          </div>
        </Modal>

        {/* -----------  CLIENTS TABLE      ------------------- */}
        {/* OLD - Multiple search fields section (COMMENTED OUT - Keep for reference) */}
        {/* {!searchAddMode && !editMode.mode && (
          <div className="client-search-panel panel">
            <div className="panel-heading">
              <h3 className="panel-title">Finlotax Details</h3>
            </div>
            <div className="panel-body">
              <Grid container alignItems="center" spacing={2}>
                {Object.keys(fieldConfiguration).map((data, index) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      md={4}
                      sm={6}
                      lg={3}
                      key={`data${index}`}
                    >
                      <Labelbox
                        type={fieldConfiguration[data]?.type || "text"}
                        labelname={fieldConfiguration[data]?.labelname}
                        password={fieldConfiguration[data]?.password}
                        dropdown={
                          fieldConfiguration[data]?.type === "select" &&
                          fieldConfiguration[data]?.dropdown
                            ? fieldConfiguration[data]?.dropdown
                            : false
                        }
                        changeData={(e) => checkValidation(e, data)}
                        disabled={fieldConfiguration[data]?.disabled}
                        value={fieldConfiguration[data]?.value || ""}
                        error={fieldConfiguration[data]?.error}
                        errmsg={fieldConfiguration[data]?.errmsg}
                        onKeyEnter={onSubmit}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <div className="client-search-actions">
                <button className="employee-btn-cancel" onClick={handleCancel}>
                  Reset
                </button>
                <Button text="Search" large handleClick={onSubmit} />
              </div>
            </div>
          </div>
        )} */}

        {!searchAddMode &&
          !editMode.mode &&
          requestMode &&
          userRole === "admin" && (
            <div className="client-request-category-switch">
              <div
                className="client-request-category-tabs"
                role="tablist"
                aria-label="New client request category"
              >
                {["Individual", "Business"].map((type) => (
                  <button
                    key={type}
                    type="button"
                    role="tab"
                    aria-selected={requestTypeTab === type}
                    onClick={() => setRequestTypeTab(type)}
                    className={`client-request-category-tab ${
                      requestTypeTab === type ? "is-active" : ""
                    }`}
                  >
                    {type}
                  </button>
                ))}
              </div>
            </div>
          )}

        {!searchAddMode && !editMode.mode && (
          <div className="employee-table-panel panel">
            <div className="panel-heading">
              <div className="panel-tools">
                <div className="dash-search">
                  <SearchIcon className="dash-search-icon" />
                  <input
                    type="text"
                    placeholder="Search by name, email or business name"
                    aria-label="Search Clients"
                    value={clientSearchQuery}
                    onChange={(e) => setClientSearchQuery(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleClientSearch();
                      }
                    }}
                  />
                </div>
                {!requestMode && (
                <div className="client-type-filter" style={{ minWidth: 160 }}>
                  <Labelbox
                    type="select"
                    labelname="Type"
                    value={clientTypeFilter}
                    dropdown={[
                      { id: "all", value: "All" },
                      { id: "Individual", value: "Individual" },
                      { id: "Business", value: "Business" },
                    ]}
                    changeData={(v) => setClientTypeFilter(v)}
                    error={false}
                    errmsg={null}
                  />
                </div>
                )}
                <div className="employee-status-indicators">
                  <span className="status-indicator">
                    <span className="status-dot status-active"></span>
                    Active
                  </span>
                  <span className="status-indicator">
                    <span className="status-dot status-inactive"></span>
                    Inactive
                  </span>
                </div>
              </div>
            </div>
            <Table
              title=""
              header={clientTableHeader}
              data={tableData}
              EnableSno={true}
              actions={clientTableActions}
              onActionClick={onAction}
              restrictActionIcon={true}
              hiddenFields={[
                "enabledActions",
                "client_id",
                "listDisplayEmail",
                "_clientData",
                "_services",
                "_serviceData",
                "_serviceIndex",
              ]}
              aligncss="dashboard-table"
              className="client-table-scope"
            />
          </div>
        )}
      </Grid>
    </div>
  );
};

export default CreateClient;
